import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, GuardResult, MaybeAsync } from '@angular/router';
import { SessionService } from '../session.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate,CanActivateChild {
    constructor(
        private router: Router,
        private sessionService: SessionService
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
       return this.isAuthenticated(state);
    }
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    
        return this.isAuthenticated(state);
    }

     private isAuthenticated(state:RouterStateSnapshot):boolean{
         if (this.sessionService.isLoggedIn) {
            return true;
        }

        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

}

